import axios from 'axios'
import router from '@/router'
import { eventTypes } from '@/helpers/event-helpers'
import * as alertTypes from '@/helpers/alert-types'

const fetchGraph = async ({ commit, rootState, dispatch }, payload) => {
  await axios.get(`${rootState.baseURL}/properties/graph/${payload.id}/${payload.startTime}/${payload.endTime}`, {})
    .then((res) => {
      if (res) {
        commit('updateGraphData', res.data.data)
      }
    })
}

const fetchGraphEvents = async ({ commit, rootState }, payload) => {
  await axios.post(`${rootState.baseURL}/events/list`, {
    filter: [
        { key: 'start_time', operator: '>=', value: payload.startTime },
        { key: 'event_class', operator: 'in', value: [eventTypes.NOISE, eventTypes.DISCONNECT].join(',') },
        { key: 'property_id', operator: '=', value: payload.id },
      ],
    pagination: { perPage: 999 },
  }).then(res => {
    if (res) {
      commit('updateGraphEvents', res.data.data)
    }
  })
}

const fetchGraphAlerts = async ({ commit, rootState }, payload) => {
  await axios.post(`${rootState.baseURL}/alerts/list`, {
    filter: [
        { key: 'created_at', operator: '>=', value: payload.startTime },
        { key: 'created_at', operator: '<=', value: payload.endTime },
        { key: 'alert_type', operator: 'in', value: Object.values(alertTypes).join(',') },
        { key: 'property_id', operator: '=', value: payload.id },
      ],
    pagination: { perPage: 999 },
  }).then(res => {
    if (res) {
      commit('updateGraphAlerts', res.data.data)
    }
  })
}

const fetchThresholds = async ({ commit, rootState }, { propertyId }) => {
  await axios.post(`${rootState.baseURL}/thresholds/list`, {
    filter: [{ key: 'property_id', operator: '=', value: propertyId }],
    pagination: { perPage: 999 },
  })
  .then(res => {
    if (res) {
      commit('updateThresholds', res.data.data)
    }
  })
}

const fetchPropertyListFilters = async ({ rootState }, { key, ...payload }) => {
  return await axios.post(`${rootState.baseURL}/properties/list/filter/${key}/values`, payload, {})
}

const fetchPropertyDetails = async ({ rootState, commit }, propID) => {
  await axios.get(`${rootState.baseURL}/properties/${propID}`)
    .then(res => {
      if (res) {
        commit('setPropertyDetails', res.data.data)
      }
    })
}

const createProperty = async ({ rootState, commit, dispatch }, payload) => {
  await axios.post(`${rootState.baseURL}/properties/`, payload)
  .then((res) => {
    if (res) {
      const payload = { type: 'success', text: 'Successfully created property' }
      dispatch('updateMessages', payload, { root: true })
      router.push({ path: `/properties/${res.data.data.id}` })
    }
  })
}

const createBulkProperty = async ({ rootState, commit, dispatch }, payload) => {
  await axios.post(`${rootState.baseURL}/properties/bulk`, payload)
  .then((res) => {
      const payload = { type: 'success', text: `Successfully created ${res.data.data.length} properties` }
      dispatch('updateMessages', payload, { root: true })
  })
}

const updatePropertyDetails = async ({ rootState, commit, dispatch }, { propertyId, payload }) => {
  await axios.put(`${rootState.baseURL}/properties/${propertyId}`, payload)
  .then((res) => {
    if (res) {
      commit('setPropertyDetails', res.data.data)
      const payload = { type: 'success', text: 'Successfully updated property' }
      dispatch('updateMessages', payload, { root: true })
      router.push({ path: `/properties/${propertyId}` })
    }
  })
}

const deleteProperty = async ({ rootState, commit, dispatch }, propertyId) => {
  await axios.delete(`${rootState.baseURL}/properties/${propertyId}`)
    .then((res) => {
      if (res) {
        const payload = { type: 'success', text: 'Successfully deleted property' }
        dispatch('updateMessages', payload, { root: true })
        router.push({ path: '/properties/' })
      }
    })
}

export default {
  fetchGraph,
  fetchGraphEvents,
  fetchGraphAlerts,
  fetchThresholds,
  fetchPropertyListFilters,
  fetchPropertyDetails,
  createProperty,
  createBulkProperty,
  updatePropertyDetails,
  deleteProperty,
}
